import React from 'react'
import Menu from './components/Menu'
import { Route, Switch } from 'react-router-dom'
import RouteErrorsNotFound from 'routes/errors/404'
import RouteErrorsMaintenance from 'routes/errors/maintenance'
import RouteErrorsDynamic from 'routes/errors/dynamic'
import { LayoutWithStandardHeader as Layout } from 'stylist'

const RouteErrors = () => (
  <Layout>
    <Layout.Header homeRoute="/">
      <Menu />
    </Layout.Header>
    <Layout.Main>
      <Switch>
        <Route path="/maintenance" component={RouteErrorsMaintenance} />
        <Route path="/error" component={RouteErrorsDynamic} />
        <Route path="/*" component={RouteErrorsNotFound} />
      </Switch>
    </Layout.Main>
  </Layout>
)

export default RouteErrors



// WEBPACK FOOTER //
// ./src/routes/errors.js